import { ChevronRight, Search } from "lucide-react";
import { useState } from "react";
import { Link, useRouter } from "../router/Router";
import { CATEGORIES, guidesByCategory } from "../content/registry";
import { CategoryIcon } from "../components/Icon";
import { Seo } from "../components/Seo";

const POPULAR = [
  "/screens/pair-a-screen",
  "/screens/assign-content",
  "/screens/view-wall",
  "/apps/add-an-app",
  "/getting-started/welcome-tour",
];

export function HomePage() {
  const { navigate } = useRouter();
  const [q, setQ] = useState("");

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (q.trim()) navigate(`/search?q=${encodeURIComponent(q.trim())}`);
  };

  return (
    <div className="hc-home">
      <Seo
        title="Help Center"
        description="Step-by-step guides for using PulsePanels."
        path="/"
      />

      <section className="hc-hero">
        <h1 className="hc-hero__title">How can we help?</h1>
        <p className="hc-hero__sub">
          Step-by-step guides for pairing screens, managing content, and setting
          up every app and module.
        </p>
        <form className="hc-hero__search" onSubmit={submit} role="search">
          <Search size={18} aria-hidden="true" />
          <input
            type="search"
            placeholder="Search for a guide, e.g. “pair a screen”"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            aria-label="Search guides"
          />
          <button type="submit">Search</button>
        </form>
        <div className="hc-hero__popular">
          <span>Popular:</span>
          {POPULAR.map((route) => {
            const g = guidesByCategory("getting-started")
              .concat(
                guidesByCategory("screens"),
                guidesByCategory("apps"),
              )
              .find((x) => x.route === route);
            return g ? (
              <Link key={route} to={route} className="hc-hero__pill">
                {g.title}
              </Link>
            ) : null;
          })}
        </div>
      </section>

      <section className="hc-cats">
        {CATEGORIES.map((cat) => {
          const count = guidesByCategory(cat.id).length;
          return (
            <Link
              key={cat.id}
              to={`/${cat.id}`}
              className="hc-cat-card"
              style={{ ["--accent" as string]: cat.accent }}
            >
              <span className="hc-cat-card__icon">
                <CategoryIcon name={cat.icon} />
              </span>
              <span className="hc-cat-card__body">
                <span className="hc-cat-card__label">
                  {cat.label}
                  <ChevronRight size={16} aria-hidden="true" />
                </span>
                <span className="hc-cat-card__desc">{cat.description}</span>
                <span className="hc-cat-card__count">{count} guides</span>
              </span>
            </Link>
          );
        })}
      </section>
    </div>
  );
}
